import React from 'react';

import LibraryActions from 'actions/library/LibraryActions';

import Card from 'material-ui/Card/Card';
import Button from '@material-ui/core/Button';

/**
 * Search tab for the library page.
 */
export default class LibraryCreateTab extends React.Component {
  handleCreateLibrary = () => {
    setImmediate(() => LibraryActions.showCreateOrUpdateLibraryDialog());
  };

  render() {
    return (
      <Card className="create plain-border">
        <div className="header">
          <h2 style={{fontWeight: 'bold'}}>Create Library</h2>
        </div>
        <div className="text">
          Create your own library to curate calls that you want to refer to in future.
        </div>
        <Button variant="outlined" onClick={this.handleCreateLibrary}>
          Create Library
        </Button>
      </Card>
    );
  }
}
